import { Eye, EyeOff } from 'lucide-react';

import { Button } from '@/components/ui/button';

type Props = {
  state: boolean;
  toggle: () => void;
};

export const ShowHideButton = ({ state, toggle }: Props) => {
  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      className="h-full bg-transparent hover:bg-transparent"
      onClick={toggle}
      aria-label={state ? 'Hide Password' : 'Show Password'}
    >
      {state ? <Eye className="h-4 w-4" /> : <EyeOff className="h-4 w-4" />}
    </Button>
  );
};
